import { Key, listen, storageEvents } from '@soluto-private/mx-context';
import { setPartnerLocale } from '../partner-languages/partnerLanguages';
var registerToContextEvents = function (i18nClient) {
    listen(storageEvents.keyUpdated(Key.Client), setPartnerLocale);
    listen(storageEvents.keyUpdated(Key.Language), function () {
        i18nClient.changeLanguage();
    });
};
export { registerToContextEvents };
